import React from 'react';
import { InputBase, CustomDateInput } from '../../../Helper/InputBase';
import { formatter } from '../../../../utility';
import moment from 'moment';

const DROPDOWN_NO_VALUE = '0';
const DROPDOWN_YES_VALUE = '1';

const PriorRentIncreaseQuestions = (props) => {
  const { decisionDate, isPreviousYearRentIncrease, previousYearRentIncreaseDate, errors, handleIsPreviousYearRentIncrease, handleDateChange, disabled } = props;

  const eightMonthsBeforeDecisionDate = moment(decisionDate).startOf('month').subtract(8, 'months').toDate();
  const previousRentIncreaseLabel = `Did you issue a notice for an annual allowable rent increase that became effective in the 8 months prior to the decision
  ${eightMonthsBeforeDecisionDate && decisionDate ? ` (between ${formatter.toDateDisplay(eightMonthsBeforeDecisionDate)} and ${formatter.toDateDisplay(decisionDate)})` : ''}?`; 

  const renderRentIncreaseDate = () => {
    if (isPreviousYearRentIncrease !== DROPDOWN_YES_VALUE) return;
    return (
      <div className="pri-questions__input-wrapper">
        <CustomDateInput
          name='previousYearRentIncreaseDate'
          disabled={disabled}
          value={previousYearRentIncreaseDate}
          errors={errors.previousYearRentIncreaseDate}
          cssClass='pri-questions__decision-date'
          minDate={eightMonthsBeforeDecisionDate}
          maxDate={decisionDate}
          label='What was the effective date of this prior rental increase?'
          handleChange={handleDateChange}
        />
      </div>
    )
  }

  return (
    <div className="pri-questions">
      <div className="pri-questions__input-wrapper">
        <InputBase
          name='isPreviousYearRentIncrease'
          disabled={disabled}
          cssClass='pri-questions__decision'
          errors={errors.isPreviousYearRentIncrease}
          type='select'
          value={isPreviousYearRentIncrease}
          label={previousRentIncreaseLabel}
          handleSelectChange={handleIsPreviousYearRentIncrease}
          selectList={[ { text: 'No', value: DROPDOWN_NO_VALUE }, { text: 'Yes', value: DROPDOWN_YES_VALUE } ]}
        />
      </div>

      {renderRentIncreaseDate()}
    </div>
  )
}

export default PriorRentIncreaseQuestions;